import { reactive } from 'vue'
import dayjs from 'dayjs'
import Litepicker from 'litepicker'
require('dayjs/locale/es')
dayjs.locale('es')

let litePickerInstance = reactive({})

const getDateFormat = (format) => {
  return format !== undefined ? format : 'DD-MM-YYYY'
}

const init = (el, props, emit) => {
  const format = getDateFormat(props.options.format)
  litePickerInstance = new Litepicker({
    element: el,
    ...props.options,
    format: format,
    setup: (picker) => {
      picker.on('selected', (startDate, endDate) => {
        let date = dayjs(startDate.dateInstance).format(format)
        date +=
          endDate !== undefined
            ? ' - ' + dayjs(endDate.dateInstance).format(format)
            : ''
        emit('update:modelValue', date)
      })
      picker.on('clear:selection', () => {
        picker.hide()
        emit('update:modelValue', '')
      })
    }
  })
}

const reInit = (el, props, emit) => {
  litePickerInstance.destroy()
  init(el, props, emit)
}

export { init, reInit }
